import React from 'react';

const CancerIcon = ({ width = '80', height = '80', color = '#f1c40f' }) => (
  <svg width={width} height={height} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M25 40C10 40 5 55 20 65" stroke={color} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="28" cy="35" r="8" fill={color}/>
    <path d="M75 60C90 60 95 45 80 35" stroke={color} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="72" cy="65" r="8" fill={color}/>
  </svg>
);

export default CancerIcon;
